<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="toc">
<h1 class="plm_hd" id="sgc-toc-level-1">Contents</h1>
<div class="sgc-toc-level-1">
<a href="#/Text/PTOP_serpref">Series preface</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/PTOP_autpref">Author’s preface</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/PTOP_abbrev">Abbreviations</a>
</div>
<div class="sgc-toc-level-1s">
<a href="#/Text/PTOP_ch01"><span class="bold2">1 Introduction</span></a>
</div>
<div class="sgc-toc-level-2">
<a href="#/Text/PTOP_ch01#sigil_toc_id_2">Thesis</a>
</div>
<div class="sgc-toc-level-2">
<a href="#/Text/PTOP_ch01#sigil_toc_id_3">Joseph in canonical context in pre-modern Christian literature</a>
</div>
<div class="sgc-toc-level-2">
<a href="#/Text/PTOP_ch01#sigil_toc_id_4">Modern scholarship on Joseph’s significance in Genesis</a>
</div>
<div class="sgc-toc-level-2">
<a href="#/Text/PTOP_ch01#sigil_toc_id_5">The use of the Joseph narrative in later Scripture</a>
</div>
<div class="sgc-toc-level-2">
<a href="#/Text/PTOP_ch01#sigil_toc_id_6">Joseph as a type of Christ in modern scholarship</a>
</div>
<div class="sgc-toc-level-2">
<a href="#/Text/PTOP_ch01#sigil_toc_id_7">Preview of the argument</a>
</div>
<div class="sgc-toc-level-1s">
<span href="#/Text/PTOP_ch02" title="Link target outside of Sample"><span class="bold2">2 Biblical theology and typology</span></span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/PTOP_ch02#sigil_toc_id_9" title="Link target outside of Sample">Defining biblical theology</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/PTOP_ch02#sigil_toc_id_10" title="Link target outside of Sample">Defining typology</span>
</div>
<div class="sgc-toc-level-1s">
<span href="#/Text/PTOP_ch03" title="Link target outside of Sample"><span class="bold2">3 The Joseph story in Genesis’ </span><span class="bolditalic2">tôlĕdôt</span><span class="bold2"> structure</span></span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/PTOP_ch03#sigil_toc_id_12" title="Link target outside of Sample">Function of the <span class="italic2">tôlĕdôt</span> formula: tracing God’s promise through each generation</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/PTOP_ch03#sigil_toc_id_13" title="Link target outside of Sample">The <span class="italic2">tôlĕdôt</span> structure and the story of Joseph</span>
</div>
<div class="sgc-toc-level-1s">
<span href="#/Text/PTOP_ch04" title="Link target outside of Sample"><span class="bold2">4 Joseph and covenant: kingship</span></span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/PTOP_ch04#sigil_toc_id_15" title="Link target outside of Sample">Introducing Joseph and Genesis 37 – 50</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/PTOP_ch04#sigil_toc_id_16" title="Link target outside of Sample">Joseph in biblical-theological perspective</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/PTOP_ch04#sigil_toc_id_17" title="Link target outside of Sample">Royal seed: primeval types and promises</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/PTOP_ch04#sigil_toc_id_18" title="Link target outside of Sample">Royal seed: Abrahamic types and promises</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/PTOP_ch04#sigil_toc_id_19" title="Link target outside of Sample">Joseph: Abraham’s royal seed</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/PTOP_ch04#sigil_toc_id_20" title="Link target outside of Sample">Joseph and Judah: present and future royal seed</span>
</div>
<div class="sgc-toc-level-1s">
<span href="#/Text/PTOP_ch05" title="Link target outside of Sample"><span class="bold2">5 Joseph and covenant: seed</span></span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/PTOP_ch05#sigil_toc_id_22" title="Link target outside of Sample">The ‘seed’ theme in Genesis</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/PTOP_ch05#sigil_toc_id_23" title="Link target outside of Sample">Preservation and proliferation</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/PTOP_ch05#sigil_toc_id_24" title="Link target outside of Sample">Seed conflict and sibling rivalry</span>
</div>
<div class="sgc-toc-level-1s">
<span href="#/Text/PTOP_ch06" title="Link target outside of Sample"><span class="bold2">6 Joseph and covenant: land and blessing</span></span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/PTOP_ch06#sigil_toc_id_26" title="Link target outside of Sample">The land theme in Genesis</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/PTOP_ch06#sigil_toc_id_27" title="Link target outside of Sample">The Promised Land in the story of Joseph</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/PTOP_ch06#sigil_toc_id_28" title="Link target outside of Sample">Blessing in Genesis</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/PTOP_ch06#sigil_toc_id_29" title="Link target outside of Sample">Blessing in the Joseph story</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/PTOP_ch06#sigil_toc_id_30" title="Link target outside of Sample">Other possibly significant biblical-theological features of the Joseph story</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/PTOP_ch06#sigil_toc_id_31" title="Link target outside of Sample">Suffering, glory and the promise-keeping God: synthesizing the major themes of the Joseph story</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/PTOP_ch06#sigil_toc_id_32" title="Link target outside of Sample">Implications for a canonical understanding of the Joseph narrative</span>
</div>
<div class="sgc-toc-level-1s">
<span href="#/Text/PTOP_ch07" title="Link target outside of Sample"><span class="bold2">7 Joseph in the Old Testament</span></span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/PTOP_ch07#sigil_toc_id_34" title="Link target outside of Sample">Joseph and the exodus</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/PTOP_ch07#sigil_toc_id_35" title="Link target outside of Sample">Joseph in Psalm 105</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/PTOP_ch07#sigil_toc_id_36" title="Link target outside of Sample">Joseph and Daniel</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/PTOP_ch07#sigil_toc_id_37" title="Link target outside of Sample">The exalted Jew in a foreign court</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/PTOP_ch07#sigil_toc_id_38" title="Link target outside of Sample">Implications for a canonical understanding of the Joseph narrative</span>
</div>
<div class="sgc-toc-level-1s">
<span href="#/Text/PTOP_ch08" title="Link target outside of Sample"><span class="bold2">8 Joseph in the New Testament</span></span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/PTOP_ch08#sigil_toc_id_40" title="Link target outside of Sample">Joseph in Acts 7</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/PTOP_ch08#sigil_toc_id_41" title="Link target outside of Sample">Joseph in Hebrews 11</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/PTOP_ch08#sigil_toc_id_42" title="Link target outside of Sample">Allusions to the Joseph story in the parable of the tenants</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/PTOP_ch08#sigil_toc_id_43" title="Link target outside of Sample">Implications for a canonical understanding of the Joseph narrative</span>
</div>
<div class="sgc-toc-level-1s">
<span href="#/Text/PTOP_ch09" title="Link target outside of Sample"><span class="bold2">9 Conclusion</span></span>
</div>
<div class="sgc-toc-level-1s">
<span href="#/Text/PTOP_bibliog" title="Link target outside of Sample">Bibliography</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/PTOP_notes" title="Link target outside of Sample">Notes</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/PTOP_idx_aut" title="Link target outside of Sample">Search terms for authors</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/PTOP_idx_scr" title="Link target outside of Sample">Search terms for Scripture references</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/PTOP_series" title="Link target outside of Sample">Titles in this series</span>
</div>
<div class="sgc-toc-level-1"><span href="#/Text/author" title="Link target outside of Sample">About the Authors</span></div>
<div class="sgc-toc-level-1"><span href="#/Text/moreIVP" title="Link target outside of Sample">More Titles from InterVarsity Press</span></div>
<div class="sgc-toc-level-1"><span href="#/Text/IVPtbs" title="Link target outside of Sample">IVP Academic Textbook Selector</span></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// PTOP_contents.vue?7dc9eb3a